"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function InfoLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const links = [
    { href: '/about', label: 'Про нас' },
    { href: '/delivery', label: 'Оплата і доставка' },
    { href: '/returns', label: 'Обмін, повернення та гарантія' },
    { href: '/contacts', label: 'Контакти' },
    { href: '/terms', label: 'Угода користувача' },
    { href: '/privacy', label: 'Політика конфіденційності' },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row gap-8">
      
      {/* Ліве меню навігації з активним станом */}
      <aside className="w-full md:w-1/4 shrink-0">
        <nav className="flex flex-col gap-1 bg-white rounded-xl shadow-sm border border-gray-100 p-4 sticky top-24">
          {links.map((link) => {
            const isActive = pathname === link.href;
            return (
              <Link 
                key={link.href} 
                href={link.href} 
                className={`p-3 rounded-md transition-all font-medium ${
                  isActive 
                    ? 'bg-[#0056b3] text-white shadow-md cursor-default pointer-events-none' 
                    : 'text-gray-700 hover:bg-gray-100 hover:text-[#0056b3]'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>
      </aside>

      {/* Основний контент сторінки */}
      <main className="w-full md:w-3/4 bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-10">
        {children}
      </main>

    </div>
  );
}
